// extracted by mini-css-extract-plugin
export default {"actions":"ErrorPage_actions__QWtSu","buttonLink":"ErrorPage_buttonLink__T7606","shoppingLink":"ErrorPage_shoppingLink__QRf6W"};